import { z } from 'zod';

export type Agreement = z.infer<typeof agreementSchema>;

export const agreementSchema = z.object({
  role: z.string(),
  signed: z.boolean(),
  signer: z.object({
    key: z.string(),
    email: z.string().nullable().optional(),
    phoneNumber: z.string().nullable().optional(),
    name: z.string().nullable().optional(),
  }),
});

export const agreementsDataSchema = z.object({
  agreements: z.array(agreementSchema),
});
